import { put, call, takeEvery } from 'redux-saga/effects';
import { api } from '../../../lib/http';
import { checkWholesalerDomain } from '../../../lib/utils';
import { wholesalerSubdomainGetSuccess } from './actions';
import * as TYPES from './types';

export default function* wholesalerSagas() {
    yield takeEvery(TYPES.WHOLESALER_SUBDOMAIN_GET_REQUEST, wholesalerGetRequest);
}

function* wholesalerGetRequest() {
    const hostCheck = checkWholesalerDomain();
    if (!hostCheck.isGB) {
        try {
            const response = yield call(api.get, `wholesalers/subdomain/${hostCheck.subdomain}`, {
                params: {
                    return_only: 'id,company_name,logo,subdomain,contact_url,header_config',
                },
            });
            yield put(wholesalerSubdomainGetSuccess(response.data)); // Dispatch success action with data
        } catch (e) {
            console.error(e); // Log error
        }
    }
}
